import { combineReducers } from 'redux';
import authReducer from './auth';
import i18nReducer from './i18n';

const rootReducer = combineReducers({
    auth: authReducer,
    i18n: i18nReducer,
});

export default rootReducer;